<template>
  <v-dialog v-model="dialog">
    <v-card flat min-height="200">
      <v-toolbar dense>
        <v-toolbar-title>
          <v-icon left>{{ titleIcon }}</v-icon>
          {{ $vuetify.lang.t('$vuetify.map.travelStatsCard.clientFilesDialogButton') }}
          <span v-if="fileData.isLastUpdateAvailable" class="mx-2">({{ fileData.formattedUpdateTimestamp }})</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <tooltip-basic :text="'$vuetify.map.requests.syncFileData'"
                       :icon="syncIcon"
                       :emit-state="`request-sync-client-file`"
                       @request-sync-client-file="loadServerFiles"></tooltip-basic>

        <v-btn icon class="text-right" @click="$emit('close-server-requests-dialog')">
          <v-icon>{{ closeIcon }}</v-icon>
        </v-btn>

        <v-progress-linear :active="filesLoading" indeterminate absolute bottom>
        </v-progress-linear>

      </v-toolbar>

      <v-card-text class="py-0">
        <v-skeleton-loader :loading="filesLoading" type="card">
          <v-container class="my-auto">
            <template v-if="fileData.files.length === 0">
              <v-row>
                <v-col cols="12">
                  <v-alert color="warning" :icon="alertIcon" class="my-0">
                    {{ $vuetify.lang.t('$vuetify.map.requests.emptyData') }}
                  </v-alert>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row>
                <v-col cols="12">
                  <v-tabs v-model="tab" center-active grow>
                    <v-tab v-for="entry in tabs" :key="entry.name">
                      <v-icon left>{{ entry.icon }}</v-icon>
                      {{ $vuetify.lang.t(entry.name, getFilesSize(entry.storage)) }}
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item>
                      <files-data-iterator :items="videos" type="video"></files-data-iterator>
                    </v-tab-item>
                    <v-tab-item>
                      <files-data-iterator :items="logs" type="logs"></files-data-iterator>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </template>
          </v-container>
        </v-skeleton-loader>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import { mdiClose, mdiAlertCircle, mdiFileMultiple, mdiSync, mdiVideo, mdiFileCheck } from '@mdi/js'
import { ClientFileType, ServerRequestType } from '@/enum'
import { FileDataRequest } from '@/models/serverRequests/FileDataRequest'
import backend from '@/backend'
import { ServerFile } from '@/models/serverRequests/ServerFile'
import { ServerRequest } from '@/models/serverRequests/ServerRequest'
import FilesDataIterator from '@/components/map/serverRequests/filesDataIterator'
import TooltipBasic from '@/components/utils/tooltipBasic'
import { FileData } from '@/models/serverRequests/FileData'

const makeTab = (name, icon, storage) => ({ name, icon, storage })

export default {
  name: 'serverRequestsDialog',
  components: { TooltipBasic, FilesDataIterator },
  props: {
    dialog: Boolean,
    fileDataRequest: FileDataRequest
  },
  data: () => ({
    fileData: new FileData(),
    files: [],
    filesLoading: false,
    tab: null,
    tabs: [
      makeTab(`$vuetify.map.requests.tabs.${ClientFileType.VIDEO}`, mdiVideo, 'videos'),
      makeTab(`$vuetify.map.requests.tabs.${ClientFileType.LOG}`, mdiFileCheck, 'logs')
    ],

    titleIcon: mdiFileMultiple,
    closeIcon: mdiClose,
    alertIcon: mdiAlertCircle,
    syncIcon: mdiSync

  }),
  computed: {
    videos () {
      return this.fileData.files.filter(file => file.fileType === ClientFileType.VIDEO)
    },
    logs () {
      return this.fileData.files.filter(file => file.fileType === ClientFileType.LOG)
    }
  },
  methods: {
    getFilesSize (field) {
      return this[field] ? this[field].length : 0
    },
    async loadServerFiles () {
      const data = { ...this.fileDataRequest }
      this.filesLoading = true

      try {
        const result = await backend.fetchClientFileData(data)
        this.fileData = new FileData({ ...result.data })

        await backend.sendServerRequest(new ServerRequest({
          requestType: ServerRequestType.FILE_LIST,
          userId: this.fileDataRequest.userId
        }).backendModel())
      } catch (e) {
        console.error(e)
      } finally {
        this.filesLoading = false
      }
    }
  },
  watch: {
    async dialog (value) {
      if (value) {
        await this.loadServerFiles()
      }
    }
  }
}
</script>

<style scoped>

</style>
